/**
 * Convierte una cantidad de segundos en una representación legible de
 * días, horas y minutos.
 *
 * Reglas:
 * - Si `totalSeconds` es nulo, indefinido, no numérico o menor/igual a 0,
 *   se devuelve "0".
 * - Solo se incluyen las unidades cuyo valor sea mayor a 0.
 * - Se pluraliza correctamente (día/días, hora/horas, minuto/minutos).
 *
 * @param {number|string|null|undefined} totalSeconds - Total de segundos.
 * @returns {string[]} Partes del tiempo, p. ej. ["2 días", "3 horas", "2 minutos"].
 */
export function formatSecondsParts(totalSeconds) {
  const seconds = Number(totalSeconds);

  if (!seconds || Number.isNaN(seconds) || seconds <= 0) {
    return ["0"];
  }

  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  const parts = [];

  if (days > 0) {
    parts.push(`${days} ${days === 1 ? "día" : "días"}`);
  }
  if (hours > 0) {
    parts.push(`${hours} ${hours === 1 ? "hora" : "horas"}`);
  }
  if (minutes > 0) {
    parts.push(`${minutes} ${minutes === 1 ? "minuto" : "minutos"}`);
  }

  // Si el valor es mayor a 0 pero menor a un minuto, mostramos "0".
  return parts.length > 0 ? parts : ["0"];
}

/**
 * Devuelve el tiempo formateado como un único string separado por el
 * separador indicado (por defecto una coma). Útil para exportaciones.
 *
 * @param {number|string|null|undefined} totalSeconds - Total de segundos.
 * @param {string} [separator=", "] - Separador entre unidades.
 * @returns {string} p. ej. "2 días, 3 horas, 2 minutos".
 */
export function formatSeconds(totalSeconds, separator = ", ") {
  return formatSecondsParts(totalSeconds).join(separator);
}

export default formatSeconds;
